import React from 'react';
import type { TimelineProps as BaseTimelineProps } from 'antd';

import { Timeline } from './styled.ts';
export type { BaseTimelineProps };

export const BaseTimeline: React.FC<BaseTimelineProps> = ({ className, ...props }) => (
    <Timeline className={className} {...props} />
);
